const categoryType = {
  NEW: 'new',
  UPDATE: 'update',
};

export default categoryType;
